import * as apiFactory from "./ApiFactory";

import { UserSearchResult } from "@/models/UserSearchResult";

import { Api } from "./Api";

import type { AuditHeader } from "@/models/AuditHeader";
import type { AuditRecord } from "@/models/AuditRecord";
import type { CursorNavigation } from "@/models/CursorNavigation";

export async function getAuditActionTakens(clientName: string): Promise<string[]> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<string[]>(["api/audit", clientName]);
}

export async function GetAuditTrailRecords(
  clientName: string,
  count: number,
  auditRequest: Record<string, string | undefined>,
): Promise<CursorNavigation<AuditHeader[]>> {
  const client: Api = await apiFactory.WithBearer();

  return await client.getWithObject(`api/audit/${clientName}/${count}`, auditRequest);
}

export async function ExportAuditTrailRecords(clientName: string, auditRequest: Record<string, string>): Promise<void> {
  const client: Api = await apiFactory.WithBearer();

  await client.getWithObject(`api/audit/csv/${clientName}`, auditRequest);
}

export async function GetAuditRecord(clientName: string, auditKeyId: number): Promise<AuditRecord> {
  const client: Api = await apiFactory.WithBearer();

  return await client.get<AuditRecord>(["api/audit/record", clientName, String(auditKeyId)]);
}

export async function GetAuditUsers(clientName: string, searchString: string): Promise<UserSearchResult[]> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<UserSearchResult[]>(["api/audit/users", clientName, searchString]);
}

export async function PostAuditPause(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  await client.post(["api/recordaction/pause", clientName, brand, caseReference, fileReference]);
}

export async function PostAuditPlay(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  await client.post(["api/recordaction/resume", clientName, brand, caseReference, fileReference]);
}
